/* Green Hills Coffee USA — cart page quantity steppers
   Uses /cart/change.js then reloads. Falls back to the native
   number input + "Update cart" button when JS is unavailable. */
(function () {
  'use strict';

  function changeLine(line, qty) {
    var key = line.getAttribute('data-key');
    var body = JSON.stringify({ id: key, quantity: qty });
    line.classList.add('is-busy');
    fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body
    }).then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { line.classList.remove('is-busy'); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gh-cart-step]');
    if (!btn) return;
    var line = btn.closest('[data-gh-cart-line]');
    if (!line) return;
    var input = line.querySelector('[data-gh-cart-qty]');
    var current = parseInt(input.value, 10) || 0;
    var next = Math.max(0, current + parseInt(btn.getAttribute('data-gh-cart-step'), 10));
    changeLine(line, next);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-gh-cart-qty]');
    if (!input) return;
    var line = input.closest('[data-gh-cart-line]');
    if (!line) return;
    changeLine(line, Math.max(0, parseInt(input.value, 10) || 0));
  });
})();
